

module.exports = __webpack_require__.stylable.create(
    "ProfileHeader65519368",
    {"classes":{"root":"ProfileHeader65519368__root","wrapper":"ProfileHeader65519368__wrapper","WarpUserNameAndAvatar":"ProfileHeader65519368__WarpUserNameAndAvatar","WarpProfileInfo":"ProfileHeader65519368__WarpProfileInfo","WarpInfo":"ProfileHeader65519368__WarpInfo","ProfileUserName":"ProfileHeader65519368__ProfileUserName"},"vars":{},"stVars":{"MobileTitleFontSize":"'\"unit(fallback(--m_userNameTextSize, 20), px)\"'","DefaultFont":"\"{theme: 'Body-M', size:'24px' }\"","UserNameFont":"\"fallback(font(--userNameFont), font({theme: 'Body-M', size:'24px' }))\"","HeaderTitleColor":"\"fallback(color(--headerTitleColor), color(color-5))\"","HeaderBgColor":"\"fallback(color(--headerBgColor), color(color-1))\""},"keyframes":{}},
    "",
    18,
    "ProfileHeader65519368",
    null
);
